import { PersoneelsdienstenModel } from "@personeel/models/PersoneelsdienstenModel.ts";
import { PersoneelsdienstModel } from "@personeel/models/PersoneelsdienstModel.ts";
import { create } from "zustand";

function maakDienstSleutel(pd: PersoneelsdienstModel): string {
  return pd.standplaatsDrglptNaam + "." + pd.dienstnummer + "." + pd.starttijd.toISODate();
}

function buildDienstSleutelIndex(
  personeelsdiensten: PersoneelsdienstenModel[],
): Map<string, PersoneelsdienstModel> {
  return new Map(
    personeelsdiensten
      .flatMap((pdd) => pdd.personeelsdiensten)
      .map((pd) => [maakDienstSleutel(pd), pd]),
  );
}

type PersoneelsdienstenState = {
  personeelsdiensten: PersoneelsdienstenModel[];
  dienstSleutelIndex: Map<string, PersoneelsdienstModel>;
  setPersoneelsdiensten: (res: PersoneelsdienstenModel[]) => void;
};

export const usePersoneelsdienstenStore = create<PersoneelsdienstenState>((set) => ({
  personeelsdiensten: [],
  dienstSleutelIndex: new Map(),
  setPersoneelsdiensten: (res) =>
    set({ personeelsdiensten: res, dienstSleutelIndex: buildDienstSleutelIndex(res) }),
}));
